import { api } from "../../utils/api";
import { filterWalkthroughLogs, getWalkthroughPayload } from "./walkthroughMock";

function isAdminLogsWalkthroughMock() {
  return process.env.REACT_APP_ADMIN_LOGS_WALKTHROUGH === "1";
}

export function buildAdminLogsQueryString(filters) {
  const params = new URLSearchParams();
  params.set("page", String(filters.page));
  params.set("limit", String(filters.limit));
  if (filters.region) params.set("region", filters.region);
  if (filters.logType) params.set("logType", filters.logType);
  if (filters.method) params.set("method", filters.method);
  if (filters.statusCode) params.set("statusCode", String(filters.statusCode));
  if (filters.errorsOnly) params.set("errorsOnly", "true");
  if (filters.route) params.set("route", filters.route);
  if (filters.q) params.set("q", filters.q);
  if (filters.actorEmail) params.set("actorEmail", filters.actorEmail);
  if (filters.customerId) params.set("customerId", filters.customerId);
  if (filters.merchantStoreId) params.set("merchantStoreId", filters.merchantStoreId);
  if (filters.rego) params.set("rego", filters.rego);
  if (filters.from) params.set("from", filters.from);
  if (filters.to) params.set("to", filters.to);
  return params.toString();
}

export async function fetchAdminLogs(filters) {
  const qs = buildAdminLogsQueryString(filters);
  if (isAdminLogsWalkthroughMock()) {
    const query = Object.fromEntries(new URLSearchParams(qs));
    return { success: true, data: filterWalkthroughLogs(query) };
  }
  const response = await api(`v1/admin/logs?${qs}`, "GET");
  return response.data;
}

export async function fetchAdminLogPayload(logId) {
  if (isAdminLogsWalkthroughMock()) {
    return getWalkthroughPayload(logId);
  }
  const response = await api(`v1/admin/logs/${logId}/payload`, "GET");
  return response.data;
}
